<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Pedido</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-flex xs12 sm12 md12>
            <v-data-table
              :headers="headers_carts"
              :items="cart"
              class="elevation-1"
            >
              <template v-slot:[`item.price.cost`]="{ item }">
                {{
                  item.price.issale
                    ? item.price.discount.toFixed(2)
                    : item.price.retail.toFixed(2)
                }}
              </template>
              <template v-slot:[`item.total`]="{ item }">
                {{ item.total.toFixed(2) }}
              </template>
            </v-data-table>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="blue darken-1" text @click="close()">Fechar</v-btn>
        <v-btn
          :disabled="order.id_status == 6"
          color="red"
          text
          @click="openCancelOrderConfirm()"
          >Cancelar</v-btn
        >
        <v-btn
          :disabled="order.id_status == 4 || order.id_status == 6"
          color="yellow"
          text
          @click="updateStatus(4)"
          >Saiu para entrega</v-btn
        >
        <v-btn
          :disabled="order.id_status == 6"
          color="green"
          text
          @click="updateStatus(6)"
          >Pedido entregue</v-btn
        >
      </v-card-actions>
    </v-card>
    
    <v-dialog v-model="dialogCancelOrder" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Deseja cancelar o pedido?</span>
        </v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="closeCancelOrderConfirm()">Fechar</v-btn>
          <v-btn
            :disabled="order.id_status == 6"
            color="red"
            text
            @click="updateStatus(5)"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { UpdateOrdersStatus } from "../../graphql/orders.graphql";
import * as moment from "moment";
export default {
  props: ["cart", "order"],
  name: "CartList",
  data: () => ({
    dialog: false,
    dialogCancelOrder: false,
    editedItem: [],
    headers_carts: [
      { text: "Produto", value: "price.product.name" },
      { text: "Ean1", value: "price.product.ean1" },
      { text: "Quantidade", value: "quantity" },
      { text: "Valor", value: "price.cost" },
      { text: "Total", value: "total" }
    ]
  }),

  methods: {
    close() {
      this.$emit("update", false);
    },

    closeCancelOrderConfirm() {
      this.dialogCancelOrder = false;
    },

    openCancelOrderConfirm() {
      this.dialogCancelOrder = true;
    },

    updateStatus(status) {
      if (this.order.id && status) {
        //var time = new Date().toLocaleString();
        //const [d, m, y] = time.split("/");
        //const [y2, h] = y.split(" ");
        //time = y2 + "-" + m + "-" + d + "T" + h;
        let time = moment().format("YYYY-MM-DD HH:mm:ss");

        this.$apollo
          .mutate({
            // Query
            mutation: UpdateOrdersStatus,
            // Parameters
            variables: {
              id: parseInt(this.order.id),
              status: status,
              dt_delivered: status == 6 ? time : null
            }
          })
          .then(() => {
            this.close();
            this.$swal("Pedido atualizado com sucesso!", "", "success");
          })
          .catch(error => {
            this.close();
            this.$swal("Erro ao atualizar o pedido!", error, "error");
          });
      }
    }
  }
};
</script>

<style lang="stylus"></style>
